import { WaitEvent } from 'api/node_instances/operations/getNodeInstanceWaitEvents';
import { isRaiseable as isTargetRaiseable, raiseEvent } from './raiseEvent';

/**
 * Whether this wait event maps to a known raise endpoint. False for an
 * unresolved flow-child path (null eventType) and for any type outside the
 * file/process buckets.
 */
export const isRaiseable = (event: WaitEvent): boolean => isTargetRaiseable(event);

/**
 * Raises the event a node instance is waiting on. Keyed on zone + name (the
 * data the wait event already carries), NOT event_id — so it works from the
 * instance viewer, which never loads the events list into the redux store and
 * therefore can't use eventsSlice's raiseProcessEvent/raiseFileEvent (those
 * reject with "Event not found in state").
 *
 * A thin adapter over {@link raiseEvent} for callers holding a `WaitEvent`.
 * The POST, the type dispatch and the non-idempotency caveat all live there.
 */
export const raiseWaitEvent = async (event: WaitEvent): Promise<void> => raiseEvent(event);
